import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'WebIndex',
    component: () => import('@/components/WebIndex'),
    redirect: '/WebIndex/Home',
    children: [
      {
        path: '/WebIndex/Home',
        name: 'Home',
        component: () => import('@/views/web/Home.vue')
      },
      {
        path: '/WebIndex/DataList',
        name: 'DataList',
        component: () => import('@/views/web/DataList.vue')
      },
      {
        path: '/WebIndex/DataDtl',
        name: 'DataDtl',
        component: () => import('@/views/web/DataDtl.vue')
      }
    ]
  },
  {
    path: '/backstageIndex',
    name: 'backstageIndex',
    component: () => import('@/components/backstageIndex'),
    redirect: '/backstageIndex/articleList',
    children: [
      {
        path: '/backstageIndex/articleList',
        name: 'articleList',
        component: () => import('@/views/background/articleManage/articleList'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/backstageIndex/columnList',
        name: 'columnList',
        component: () => import('@/views/background/articleManage/columnList')
      },
      {
        path: '/backstageIndex/addColumn',
        name: 'addColumn',
        component: () => import('@/views/background/articleManage/addColumn')
      },
      {
        path: '/backstageIndex/addArticle',
        name: 'addArticle',
        component: () => import('@/views/background/articleManage/addArticle')
      },
      // 轮播管理
      {
        path: '/backstageIndex/banner',
        name: 'banner',
        component: () => import('@/views/background/bannerManage/banner'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/backstageIndex/AddBanner',
        name: 'AddBanner',
        component: () => import('@/views/background/bannerManage/AddBanner')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
